import { render, staticRenderFns } from "./ServiceAreaFormDialog.vue?vue&type=template&id=5e336a10&scoped=true"
import script from "./ServiceAreaFormDialog.vue?vue&type=script&lang=js"
export * from "./ServiceAreaFormDialog.vue?vue&type=script&lang=js"
import style0 from "./ServiceAreaFormDialog.vue?vue&type=style&index=0&id=5e336a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e336a10",
  null
  
)

export default component.exports